import { Skeleton as BackyardSkeleton, Stack } from '@backyard-ui/core';

const Skeleton = () => (
  <Stack direction="column" spacing="6">
    <Stack direction="column" spacing="2" align="flex-start">
      <BackyardSkeleton height="48px" />
      <BackyardSkeleton height="20px" width="100px" />
    </Stack>

    <Stack direction="column" spacing="2">
      <BackyardSkeleton height="24px" width="160px" />
      <BackyardSkeleton height="18px" />
    </Stack>

    <Stack spacing="4">
      <BackyardSkeleton height="28px" />
      <BackyardSkeleton height="28px" />
    </Stack>

    <Stack direction="column" spacing="6">
      <hr className="border-gray-500" />

      <Stack direction="column" spacing="2">
        <BackyardSkeleton height="24px" width="160px" />
        <BackyardSkeleton height="18px" />
        <BackyardSkeleton height="18px" />

        <div className="rounded bg-gray-100 p-2">
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
        </div>
      </Stack>

      <hr className="border-gray-500" />

      <Stack direction="column" spacing="2">
        <BackyardSkeleton height="24px" width="160px" />
        <BackyardSkeleton height="18px" />
        <BackyardSkeleton height="18px" />

        <div className="rounded bg-gray-100 p-2">
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
          <BackyardSkeleton height="18px" />
        </div>
      </Stack>
    </Stack>
  </Stack>
);

export default Skeleton;
